import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { SchedaArticolo } from './SchedaArticolo';

const INTESTAZIONI: Record<string, string> = {
  SiglaProduttore: 'Sigla',
  CodiceProduttore: 'Codice produttore',
  CodiceInterno: 'Codice interno',
  UnitaMisura: 'U.M.',
  PrezzoListino: 'Listino',
  MigliorCosto: 'Costo migliore',
  MigliorFornitore: 'Da chi',
  ScontoEffettivo: 'Sconto',
  FornitoriConOfferta: 'Fornitori',
};

export function ElencoArticoli() {
  const [articoloAperto, setArticoloAperto] = useState<string | null>(null);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Articoli</h1>
            <p>
              Un articolo è la coppia sigla produttore + codice: è questo che rende confrontabili
              le voci arrivate da distributori diversi. Apri una riga per vedere chi lo vende.
            </p>
          </div>
        </header>

        <DataGrid
          nomeGriglia="articoli"
          colonneVisibili={[
            'SiglaProduttore',
            'Produttore',
            'CodiceProduttore',
            'Descrizione',
            'UnitaMisura',
            'PrezzoListino',
            'MigliorCosto',
            'MigliorFornitore',
            'ScontoEffettivo',
            'FornitoriConOfferta',
            'Attivo',
          ]}
          intestazioni={INTESTAZIONI}
          idSelezionato={articoloAperto}
          onRigaSelezionata={(riga) => {
            const id = riga['Id'];
            if (typeof id === 'string') setArticoloAperto(id);
          }}
        />
      </div>

      {articoloAperto && (
        <SchedaArticolo articoloId={articoloAperto} onChiudi={() => setArticoloAperto(null)} />
      )}
    </section>
  );
}
